export default "__VITE_ASSET__BeU8QVxA__"